// extracted by mini-css-extract-plugin
export default {"MyProfile":"MyProfile_MyProfile__qzEKy"};